/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { useLocation, matchPath } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';

import {
  Box,
  Divider,
  Drawer,
  Hidden,
  List,
  ListSubheader,
  Typography,
  makeStyles
} from '@material-ui/core';

import {
  Calendar as CalendarIcon,
  DollarSign as DollarSignIcon,
  PieChart as PieChartIcon,
  Users as UsersIcon,
  Wifi as WifiIcon,
  BookOpen as BookIcon,
  ZoomIn as ZoomInIcon,
  Flag as FlagIcon,
  Bell as BellIcon
} from 'react-feather';

import Logo from 'src/components/Logo';
import NavItem from './NavItem';
const navConfig = [
  {
    subheader: 'Relatórios',
    items: [
      {
        title: 'Dashboard',
        icon: PieChartIcon,
        href: '/app/reports/dashboard'
      }
    ]
  },
  {
    subheader: 'Gerenciamento',
    items: [
      {
        title: 'Funcionários',
        icon: UsersIcon,
        href: '/app/cadastros/funcionarios'
      },
      {
        title: 'Meus agendamentos',
        icon: CalendarIcon,
        href: '/app/cadastros/agenda'
      },
      {
        title: 'Agendamentos em outras localidades',
        icon: CalendarIcon,
        href: '/app/cadastros/agenda-credenciada'
      },
      {
        title: 'Financeiro',
        icon: DollarSignIcon,
        href: '/app/cadastros/financeiro'
      },
      {
        title: 'ASO',
        icon: ZoomInIcon,
        href: '/app/cadastros/consultaclinica'
      },
      
      //{
      //  title: 'Próximos Exames',
      //  icon: CornerDownRightIcon,
      //  href: '/app/cadastros/funcionarios'
      // },
      {
        title: 'eSocial',
        icon: WifiIcon,
        href: '/app/cadastros/esocial'
      },
      {
        title: 'Documentos',
        icon: BookIcon,
        href: '/app/cadastros/documentos'
      },
      {
        title: 'Próximos Exames',
        icon: FlagIcon,
        href: '/app/cadastros/proximosExames'
      },
      {
        title: 'Notificações',
        icon: BellIcon,
        href: '/app/cadastros/notificacoes'
      }
    ]
  }
];

function renderNavItems({ items, ...rest }) {
  return (
    <List disablePadding>
      {items.reduce(
        (acc, item) => reduceChildRoutes({ acc, item, ...rest }),
        []
      )}
    </List>
  );
}

function reduceChildRoutes({ acc, pathname, item, depth = 0 }) {
  const key = item.title + depth;

  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false
    });

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        key={key}
        info={item.info}
        open={Boolean(open)}
        title={item.title}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        key={key}
        info={item.info}
        title={item.title}
      />
    );
  }

  return acc;
}

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256,
    background: ' #ffffff',
    border: 'none'
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)',
    background: '#ffffff',
    border: 'none',
    display: 'flex'
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64
  },
  menu: {
    justifyContent: 'space-between',
    display: 'flex',
    flexDirection: 'column',
    height: '90vh'
  }
}));

function NavBar({ openMobile, onMobileClose }) {
  const classes = useStyles();
  const location = useLocation();
  const { user } = useSelector(state => state.account);

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <Hidden lgUp>
          <Box p={2} display="flex" justifyContent="center">
            <RouterLink to="/">
              <Logo />
            </RouterLink>
          </Box>
        </Hidden>
        <Box className={classes.menu}>
          <Box
            p={2}
            style={{
              padding: '1px',
              marginTop: '10px'
            }}
          >
            {navConfig.map(config => (
              <List
                key={config.subheader}
                subheader={
                  <ListSubheader
                    disableGutters
                    disableSticky
                    style={{
                      paddingLeft: '10px',
                      paddingTop: '20px',
                      paddingBottom: '10px',
                      fontWeight: '500',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      fontSize: '0.75rem',
                      lineHeight: ' normal',
                      letterSpacing: '0.21px',
                      textTransform: 'uppercase',
                      color: 'rgba(58, 53, 65, 0.38)'
                    }}
                  >
                    {config.subheader}
                  </ListSubheader>
                }
              >
                {renderNavItems({
                  items: config.items,
                  pathname: location.pathname
                })}
              </List>
            ))}
          </Box>
          <Box p={2}>
            <Divider />
            <Box mt={2} textAlign="center">
              <Typography variant="body2" color="textPrimary">
                {`${user.nome + ''}`}
              </Typography>

              <Typography variant="body2" color="textSecondary">
                {user.usuario}
              </Typography>
            </Box>
          </Box>
        </Box>
      </PerfectScrollbar>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
}

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

export default NavBar;
